import React from 'react'

import {
  APP_LOGOS,
  type AppNames,
  type ConfigItemType,
  Image,
  StandardTable,
} from '../../../module'
import { c } from '../../../translations/LibraryTranslationService'

type DataType = { name: AppNames; url: string }

const apps: DataType[] = [
  {
    name: 'LIBRARY',
    url: 'https://docs.pattern.com/library',
  },
  {
    name: 'ADMIN',
    url: 'https://docs.pattern.com/admin',
  },
  {
    name: 'CONNECT',
    url: 'https://docs.pattern.com/connect',
  },
  {
    name: 'PREDICT',
    url: 'https://docs.pattern.com/predict',
  },
  {
    name: 'PXM',
    url: 'https://docs.pattern.com/pxm',
  },
  {
    name: 'SHELF',
    url: 'https://docs.pattern.com/shelf',
  },
  {
    name: 'TOGGLE',
    url: 'https://docs.pattern.com/toggle-ui',
  },
]

const PatternDocs = (): React.JSX.Element => {
  const tableConfig: ConfigItemType<DataType, Record<string, unknown>>[] = [
    {
      label: c('application'),
      name: 'name',
      noSort: true,
      cell: {
        children: (data: DataType): React.JSX.Element => {
          return (
            <Image
              url={APP_LOGOS[data.name].isolated}
              style={{ height: 24, width: 'auto', justifyContent: 'start' }}
            />
          )
        },
      },
    },
    {
      label: c('url'),
      name: 'url',
      noSort: true,
      cell: {
        children: (data: DataType): React.JSX.Element => {
          return (
            <a href={data.url} target='_parent'>
              {data.url}
            </a>
          )
        },
      },
    },
  ]
  return (
    <StandardTable
      data={apps}
      config={tableConfig}
      dataKey='name'
      hasData
      successStatus
      loading={false}
      tableId='pattern-docs'
      noDataFields={{
        primaryText: c('noDataAvailable'),
      }}
      noMobileView
      customWidth='auto'
      noSort
    />
  )
}

export default PatternDocs
